<template>
  <div class="media-video" :style="videoWidthConstraints">
    <div class="media-video__wrapper">
      <div
        :id="mediaId"
        class="media-video__video"
        :class="[videoAspectRatio, videoFlipped]"
      />
    </div>

    <div class="media-video__overlay" :class="videoTrackMuted">
      <Avatar
        v-if="muteVideo"
        :src="participantPhoto"
        :name="participantName"
        size="lg"
        style="margin-top:auto;"
      />
      <span class="media-video__overlay-tag">
        <strong class="media-video__overlay-tag-name" :class="audioTrackMuted">
          {{ tagName }}
        </strong>
        <Icon
          v-if="!muteAudio"
          class="ml-1"
          name="mic-icon"
          :width="12"
          :height="12"
          color="#fff"
        />
        <Icon
          v-else
          class="ml-1"
          name="mic-off-icon"
          :width="12"
          :height="12"
          color="#cb6262"
        />
      </span>
    </div>
  </div>
</template>

<script>
import Avatar from "./Avatar";
import Icon from "./CustomIcons";
export default {
  name: "MediaVideo",
  components: {
    Icon,
    Avatar
  },
  props: {
    mediaId: {
      type: String,
      default: ""
    },
    aspect: {
      type: String,
      default: "4:3"
    },
    width: {
      type: String,
      default: "640px"
    },
    participantName: {
      type: String,
      default: ""
    },
    participantPhoto: {
      type: String,
      default: ""
    },
    tagName: {
      type: String,
      default: ""
    },
    muteVideo: {
      type: Boolean,
      default: false
    },
    muteAudio: {
      type: Boolean,
      default: false
    },
    flipped: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    videoAspectRatio() {
      const aspects = ["3:2", "4:3", "8:5", "16:9"];
      return aspects.includes(this.aspect)
        ? `ratio-${this.aspect.replace(":", "-")}`
        : `ratio-4-3`;
    },
    videoWidthConstraints() {
      return { maxWidth: this.width };
    },
    videoTrackMuted() {
      return { "media-video-track-muted": this.muteVideo };
    },
    audioTrackMuted() {
      return { "media-audio-track-muted": this.muteAudio };
    },
    videoFlipped() {
      return { "media-video-flipped": this.flipped };
    }
  }
};
</script>
